import * as React from 'react';
export var TabsContext = React.createContext({
    value: 0,
    isLazy: true,
    fullWidth: false,
    onChange: function () {
        // ..
    },
    getTabPanelProps: function () {
        return {};
    },
    getTabProps: function () {
        return {};
    },
});
export var useTabsContext = function () { return React.useContext(TabsContext); };
